import { base64UrlSafeEncodeString, stringifyParams } from 'utils/urls';

const CLASSLINK_AUTH_URL = 'https://launchpad.classlink.com/oauth2/v2/auth';

export const openClassLinkLoginPage = (redirectUri, state) => {
  const params = {
    response_type: 'code',
    client_id: process.env.REACT_APP_CLASSLINK_CLIENT_ID,
    redirect_uri: `${process.env.REACT_APP_BASE_BACKEND_URL}/${redirectUri}`,
    state: base64UrlSafeEncodeString(JSON.stringify(state)),
    scope: 'profile',
    // Include the optional code parameter to allow ClassLink SSO testing. This parameter is not required for production use.
    code: 'cltest'
  };

  window.location = `${CLASSLINK_AUTH_URL}?${stringifyParams(params)}`;
};
